export const showLiveViewNotification = () => ({ type: 'SHOW_LIVE_VIEW_NOTIFICATION'})
export const hideLiveViewNotification = () => ({ type: 'HIDE_LIVE_VIEW_NOTIFICATION'})


// WEBPACK FOOTER //
// ./src/actions/liveViewNotification.js